import { ReceiptApi } from 'common/types';
import { mapToNewReceiptTypes } from 'common/utils/taxMigrationHelpers';

export const updateToNewReceiptTypes = (data: ReceiptApi): ReceiptApi => {
	return mapToNewReceiptTypes(data);
};
